import React from "react";
import { Tooltip } from "@mui/material";

const Status = ({ statusId, disabledTooltip }) => {

    const getStatus = (statusId) => {
        switch (statusId ? statusId.toString() : null) {
            case null: return null;
            case "10" : return {
                blink: false,
                title: "Disconnected",
                name: "Hors ligne",
                color: "var(--red-base)",
                r: "6"
            };
            case "20" : return {
                blink: false,
                title: "Offline",
                name: "Hors ligne",
                color: "var(--red-base)",
                r: "6"
            };
            case "30" : return {
                blink: true,
                title: "Sleeping",
                name: "Mode absence",
                color: "var(--grey-base)",
                r: "4"
            };
            case "40" : return {
                blink: false,
                title: "Online",
                name: "Disponible",
                color: "var(--blue-base)",
                r: "6"
            };
            case "50" : return {
                blink: false,
                title: "OnlineConnecting",
                name: "Appel entrant",
                color: "var(--green-base)",
                r: "6"
            };
            case "60" : return {
                blink: false,
                title: "OnlineConnected",
                name: "En ligne",
                color: "var(--green-base)",
                r: "6"
            };
            case "70" : return {
                blink: true,
                title: "Paused",
                name: "Mode pause",
                color: "var(--carbone)",
                r: "4"
            };
            default : return {
                blink: false,
                name: "",
                title: "Pas de statut",
                color: "var(--grey-base)",
                r: "4"
            };
        }
    };

    const status = getStatus(statusId);

    return status ?
        disabledTooltip ?
            <div className={status.blink ? "blink" : ""}
                style={{ height: "20px", width: "20px", display: "flex" }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r={status.r}
                        fill={status.color}
                    />
                </svg>
            </div>
            :
            <Tooltip title={status.name} placement="left">
                <span className="statusInteractive">
                    <div className={status.blink ? "blink" : ""}
                        style={{ height: "20px", width: "20px", display: "flex" }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r={status.r}
                                fill={status.color}
                            />
                        </svg>
                    </div>
                </span>
            </Tooltip>
        : null;
};

export default Status;
